import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TranslateHelperService } from '../../services/TranslateService';

@Component({
    selector: 'self-ins-rolling',
    templateUrl: './rolling-page.component.html',
    styleUrls: ['./rolling-page.component.scss'],
    standalone: false
})
export class RollingPageComponent {
    constructor(private router: Router, public _translateService: TranslateHelperService) {}

    public gotoHome() {
        this.router.navigate(['/coverage']);
    }
}
